module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"soft limit slides reached":"Die empfohlene Anzahl an Seiten ({limit}) ist überschritten...","add slide":"Seite hinzufügen","slide name":"Seitennamen","enter slide name":"Bitte geben Sie den Seitennamen an."}}')
  delete Component.options._Ctor
}
